export function formatScore(score) {
  const roundedScore = Math.round(Number(score) || 0);
  const absoluteScore = Math.abs(roundedScore);
  const lastDigit = absoluteScore % 10;
  const lastTwoDigits = absoluteScore % 100;

  if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
    return `${roundedScore} баллов`;
  }

  if (lastDigit === 1) {
    return `${roundedScore} балл`;
  }

  if (lastDigit >= 2 && lastDigit <= 4) {
    return `${roundedScore} балла`;
  }

  return `${roundedScore} баллов`;
}
